import React from "react";

 const AdminBusinessOption = ({ type,  onRemove }) => {
  return (
    <div className="row my-2 ">
      <span className="col-4">{type}</span>
      <span className="col-2">
        <button
          onClick={() => onRemove()}
          className="btn  border-0 removebtn btn-outline-danger"
        >
          Remove
        </button>
      </span>
    </div>
  );
};
export default AdminBusinessOption